import "./index.css";
import StripeFeeCalculator from "@/components";

export function App() {
  return (
    <div className="app">
      <StripeFeeCalculator/>
    </div>
  );
}

export default App;
